/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';

import GroupBadges from 'components/Badges/GroupBadges';
import DeleteButton from 'components/Buttons/DeleteButtonCircle';
import EditButton from 'components/Buttons/EditCircleButton';
import Checkbox from 'components/Checkbox';
import Tooltip from 'components/Tooltips/Tooltip';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { AdminUser } from 'models/adminUser';
import { Group } from 'models/group';

import {
  Item,
  Info,
  CardData,
  Title,
  Description,
  Tag,
  EmailNotConfirmedTag,
  DeleteButtonContainer,
  RegisteredIcon,
  InvitedIcon,
  ExternalIcon,
  AdminIcon
} from './styles';

interface Badge {
  id: string;
  name: string;
  lastName?: string;
}

interface Props {
  title: string;
  description?: string;
  groupName?: string;
  groupNameActive?: boolean;
  emailNotConfirmed?: string;
  checked?: boolean;
  isSelectable?: boolean;
  badgesContent?: AdminUser[] | Group[] | Badge[];
  deleteMode?: boolean;
  disabled?: boolean;
  unGroup?: boolean;
  onDelete?: () => void;
  onClick?: () => void;
  fullWidth?: boolean;
  forceEdit?: boolean;
  userType?: string;
}

const StyledListItem = ({
  title,
  description,
  emailNotConfirmed,
  groupNameActive,
  groupName,
  checked,
  isSelectable,
  onClick,
  badgesContent,
  deleteMode,
  onDelete,
  disabled,
  unGroup,
  fullWidth,
  forceEdit,
  userType
}: Props) => {
  const { t } = useStoreTranslation();
  const enable = (conditions: boolean[]): boolean => conditions.every((condition) => condition === true);

  const enableEdit: boolean = useMemo(() => enable([!isSelectable, !deleteMode, !disabled]), [
    isSelectable,
    deleteMode,
    disabled,
  ]);

  const userTypeTooltip = () => {
    if (userType !== undefined) {
      switch (userType.toLowerCase()) {
        case 'admin':
          {
            return <Tooltip content={t('userList.icons.admin')} event="hover">
              <AdminIcon />
            </Tooltip>
          }
        case 'traveler':
          {
            return <Tooltip content={t('userList.icons.traveler')} event="hover">
              <RegisteredIcon />
            </Tooltip>
          }
        case 'guest':
          {
            return <Tooltip content={t('userList.icons.guest')} event="hover">
              <InvitedIcon />
            </Tooltip>
          }
        case 'invited':
          {
            return <Tooltip content={t('userList.icons.invited')} event="hover">
              <ExternalIcon />
            </Tooltip>
          }
      }
    }
  };

  const renderIcon = () => {

    if (userType !== undefined) {
      return userTypeTooltip()
    }
    else {
      return <></>
    }
  }

  return (
    <Item fullWidth={fullWidth} onClick={isSelectable ? onClick : undefined}>
      <Info>
        {renderIcon()}
        <CardData>
          <Title>{title}</Title>
          {description && <Description>{description}</Description>}
          {groupName && <Tag activeColor={groupNameActive}>{groupName}</Tag>}
          {emailNotConfirmed && <EmailNotConfirmedTag activeColor>{emailNotConfirmed}</EmailNotConfirmedTag>}
          {badgesContent && <GroupBadges itemsBadges={badgesContent} unGroup={!!unGroup} />}

        </CardData>
        {isSelectable && <Checkbox circle checked={!!checked} onChange={onClick} />}
        {(enableEdit || forceEdit) && <EditButton onClick={onClick ? onClick : () => { }} />}
        <DeleteButtonContainer>
          {!isSelectable && deleteMode && (
            <DeleteButton onClick={onDelete ? onDelete : () => { }} />
          )}
        </DeleteButtonContainer>
      </Info >
    </Item >
  );
};

export default StyledListItem;
